import { apiSlice } from './apiSlice';
import { SUBSCRIPTIONS_URL } from '../constants/constants';

export const subscriptionApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        joinSubscription: builder.mutation({
            query: (subscriptionId) => ({
                url: `${SUBSCRIPTIONS_URL}/${subscriptionId}/join`,
                method: 'PUT',
            }),
            invalidatesTags: ['User'],
        }),
        unsubscribeUserFromPlan: builder.mutation({
            query: () => ({
                url: `${SUBSCRIPTIONS_URL}/cancel`,
                method: 'DELETE',
            }),
            invalidatesTags: ['User'],
        }),
        getSubscriptionPlans: builder.query({
            query: () => `${SUBSCRIPTIONS_URL}`,
            providesTags: ['Subscription'],
        }),
        getSubscriptionPlanById: builder.query({
            query: (id) => `${SUBSCRIPTIONS_URL}/${id}`,
            providesTags: ['Subscription'],
        }),
        createSubscriptionPlan: builder.mutation({
            query: (newPlan) => ({
                url: `${SUBSCRIPTIONS_URL}`,
                method: 'POST',
                body: newPlan,
            }),
            invalidatesTags: ['Subscription'],
        }),
        updateSubscriptionPlan: builder.mutation({
            query: ({ id, ...newData }) => ({
                url: `${SUBSCRIPTIONS_URL}/${id}`,
                method: 'PUT',
                body: newData,
            }),
            invalidatesTags: ['Subscription'],
        }),
        deleteSubscriptionPlan: builder.mutation({
            query: (id) => ({
                url: `${SUBSCRIPTIONS_URL}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Subscription'],
        }),
        getUsedItems: builder.query({
            query: () => `${SUBSCRIPTIONS_URL}/used-items`
        }),
    }),
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
    useJoinSubscriptionMutation,
    useUnsubscribeUserFromPlanMutation,
    useGetSubscriptionPlansQuery,
    useGetSubscriptionPlanByIdQuery,
    useCreateSubscriptionPlanMutation,
    useUpdateSubscriptionPlanMutation,
    useDeleteSubscriptionPlanMutation,
    useGetUsedItemsQuery,
} = subscriptionApiSlice;